import { PackageOpen } from 'lucide-react'

interface EmptyStateProps {
  message: string
  icon?: React.ComponentType<{ className?: string }>
}

export function EmptyState({ message, icon: Icon = PackageOpen }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-xl border-2 border-dashed border-neutral-200 py-16 text-center">
      <Icon className="mb-3 h-12 w-12 text-neutral-300" />
      <p className="text-sm text-neutral-500">{message}</p>
    </div>
  )
}
